export default "__VITE_ASSET__BwNXn7R8__"